import type { Case } from '../types';
import { useApi } from '../api/useApi';
import { useCaseActions } from '../../redux/actions/caseActions';

export const CaseApiRoutes = {
    getCase: (accountId: string, caseId: string) =>
        `account/${encodeURIComponent(accountId)}/case/${encodeURIComponent(caseId)}`,
};

export type CaseService = {
    getCaseAsync: (accountId: string, caseId: string) => Promise<Case>;
};

/**
 * Fetches the portal's case using explicit IDs and stores it in Redux, without loading account state.
 */
export const useCaseService = (): CaseService => {
    const api = useApi<Case>('api/Case');
    const { setCase } = useCaseActions();

    const getCaseAsync = async (accountId: string, caseId: string): Promise<Case> => {
        if (!accountId?.trim()) {
            throw new Error('Account ID is required');
        }
        if (!caseId?.trim()) {
            throw new Error('Case ID is required');
        }

        const caseObj: Case | undefined = await api.getAsync(CaseApiRoutes.getCase(accountId, caseId));
        if (!caseObj) {
            throw new Error(`Case with ID ${caseId} not found`);
        }
        setCase(caseObj);
        return caseObj;
    };

    return { getCaseAsync };
};
